"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * IScoreGolfPlus Development
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: 1.1.56-production
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignUpBodyToJSON = exports.SignUpBodyFromJSONTyped = exports.SignUpBodyFromJSON = void 0;
function SignUpBodyFromJSON(json) {
    return SignUpBodyFromJSONTyped(json, false);
}
exports.SignUpBodyFromJSON = SignUpBodyFromJSON;
function SignUpBodyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'phoneNumber': json['phoneNumber'],
        'email': json['email'],
        'password': json['password'],
        'confirmPassword': json['confirmPassword'],
    };
}
exports.SignUpBodyFromJSONTyped = SignUpBodyFromJSONTyped;
function SignUpBodyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'firstName': value.firstName,
        'lastName': value.lastName,
        'phoneNumber': value.phoneNumber,
        'email': value.email,
        'password': value.password,
        'confirmPassword': value.confirmPassword,
    };
}
exports.SignUpBodyToJSON = SignUpBodyToJSON;
